module.exports = __webpack_public_path__ + "static/media/eps.d2a9bd47.jpeg";